import React         from 'react';
import { Component } from 'react';
import { connect }   from 'react-redux';
import { Routes as RRRoutes }    from 'react-router-dom';
import { Route }     from 'react-router-dom';
import { Navigate }  from 'react-router-dom';
import { NavLink }   from 'react-router-dom';

//Import documentation
import Tools      from './tools';
import Components from './components';

//css
import './index.scss';

//routing constants
import * as Routes    from './doc-routes';
import * as TopRoutes from 'constants/routes';


class Documentation extends Component {
    render() {
        return (
            <div className="documentation-wrapper">
                <div className="menu-wrapper">
                    <NavLink to = { Routes.tools } activeClassName='active' className="docs-category-item">Tools</NavLink>
                    <NavLink to = { Routes.components } activeClassName='active' className="docs-category-item">Components</NavLink>
                </div>
                <RRRoutes>
                    <Route exact path={ TopRoutes.docs }>
                        <Navigate to={ Routes.tools } />
                    </Route>
                    <Route path={ Routes.tools } element={ <Tools/> }/>
                    <Route path={ Routes.components } element={ <Components/> }/>
                </RRRoutes>
            </div>
        )
    }
}

//get required state from redux store and map them to the components props
const mapStateToProps = store => {
    return {
        deviceState: store.deviceState,
    }
}
export default connect(mapStateToProps, null, null)(Documentation);
